import { useCallback } from 'react'
import { AnalyticsEvents } from '../../types/analytics/analyticsEvents.enum'
import { NavigationOpenedEventProperties } from '../../types/analytics/analyticsEventProperties'
import { useSendGTMEvent } from './useSendGTMEvent'
import { useSendSegmentEvent } from './useSendSegmentEvent'

export const useSendNavigationOpenedEvent = () => {
  const { sendSegmentTrackEvent } = useSendSegmentEvent<NavigationOpenedEventProperties>()
  const sendGTMEvent = useSendGTMEvent<NavigationOpenedEventProperties>()

  const sendLinkClickedEvent = useCallback(
    (navigationOpenedEventProperties: NavigationOpenedEventProperties) => {
      sendSegmentTrackEvent(AnalyticsEvents.NAVIGATION_OPENED, navigationOpenedEventProperties)
      sendGTMEvent(AnalyticsEvents.NAVIGATION_OPENED, navigationOpenedEventProperties)
    },
    [sendSegmentTrackEvent, sendGTMEvent],
  )

  return sendLinkClickedEvent
}
